export enum OrderState {
  CODE_ORDER_REQUESTED = 'REQUESTED',
  CODE_ORDER_IN_PROGRESS = 'IN_PROGRESS',
  CODE_ORDER_PROCESSED = 'PROCESSED',
  CODE_ORDER_IMPORT_IN_PROGRESS = 'IMPORT_IN_PROGRESS',
  CODE_ORDER_GENERATED = 'GENERATED',
  CODE_ORDER_DOWNLOADED = 'DOWNLOADED',
  CODE_ORDER_FAILED = 'FAILED'
}
